import axios from "axios";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import SearchBox from "../../../common/SearchBox";
import Table from "../../../common/Table/Table";
import { errorToast, successToast } from "../../../react-toastfiy/toast";
import auctionService from "../../../services/auction/auction.service";
import CreateBrandStatesModalPopup from "./CreateBrandStatesModalPopup";

const ManageBrandStates = () => {
  const token = localStorage.getItem("refreshToken");
  const user = jwtDecode(token);
  const history = useHistory();
  const source = axios.CancelToken.source();
  const [loading, setLoading] = useState(false);
  const [stateData, setStateData] = useState([]);
  const [brandStateData, setBrandStateData] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [arrayLength, setArrayLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [modal, setModal] = useState(false);

  useEffect(() => {
    document.title = "Manage brand state";
  }, []);

  let initialValue = {
    account_holder_name: "",
    account_number: "",
    bank_name: "",
    branch_name: "",
    brand_id: "",
    brand_name: "",
    ifsc: "",
    no: "",
    state_id: "",
    state_name: "",
    suffix_account_number: "",
    prefix_account_number: "",
    is_acc_no_dynamic: false,
  };
  const [modalData, setModalData] = useState(initialValue);

  useEffect(() => {
    try {
      setLoading(true);
      auctionService.GetBrandState(source).then((res) => {
        setLoading(false);
        if (res?.status === 200) {
          const brand_list = res?.data?.map((val, index) => {
            return {
              ...val,
              no: (currentPage - 1) * itemsPerPage + (index + 1),
            };
          });
          setBrandStateData(brand_list);
          setFilteredData(brand_list);
          const lenTrans = res[0]?.brand_states_count;
          setArrayLength(lenTrans);
        } else {
          setBrandStateData([]);
        }
      });
    } catch (error) {
      errorToast(error.msg);
    }
  }, [currentPage]);
  useEffect(() => {
    try {
      auctionService.GetAllBrand().then((res) => {
        if (res?.status === 200) {
          const brand_list = res?.data?.map((val, index) => ({
            label: val?.name,
            value: val,
          }));
          setBrandList(brand_list);
        } else {
          setBrandList([]);
        }
      });
      auctionService.GetAllAuctionState().then((res) => {
        if (res.status === 200) {
          const state_list = res?.data?.map((val) => ({
            value: val,
            label: val?.name,
          }));

          setStateData(state_list);
        } else {
          errorToast(res?.msg);
        }
      });
    } catch (error) {
      errorToast(error?.msg);
    }
  }, []);

  const handleDelete = (e, rowData) => {
    e.preventDefault();
    const form_data = new FormData();
    form_data.append("brand_id", rowData.brand_id);
    form_data.append("state_id", rowData.state_id);
    Swal.fire({
      title: "Are you sure?",
      html: `<p>You want to delete this Brand State!</p>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await auctionService.DeleteBrandState(
            form_data,
            source
          );
          if (response?.status === 200) {
            window.location.reload();
            successToast(response?.msg);
          } else {
            errorToast(response?.msg);
          }
        } catch (error) {
          console.log(error);
          errorToast(error?.message);
        }
      },
    });
  };

  const columns = [
    {
      title: "#",
      data_key: "no",
    },
    {
      title: "Brands",
      data_key: "brand_name",
    },
    {
      title: "State",
      data_key: "state_name",
    },
    {
      title: "Bank Name",
      data_key: "bank_name",
    },
    {
      title: "Account Holder Name",
      data_key: "account_holder_name",
    },
    {
      title: "Account No",
      data_key: "account_number",
      render: (row) => (
        <span>
          {row?.is_acc_no_dynamic
            ? `${row.prefix_account_number}(Loan No.)`
            : row.account_number}
        </span>
      ),
    },
    {
      title: "Branch",
      data_key: "branch_name",
    },
    {
      title: "Ifsc",
      data_key: "ifsc",
    },
    {
      title: "Edit/Delete",
      data_key: "",
      render: (row) => (
        <span className=" text-nowrap">
          <i
            className="bi bi-pencil-square"
            onClick={() => {
              setModalData(row);
              setModal(true);
            }}
            style={{ cursor: "pointer" }}
          ></i>
          <i
            className="bi bi-trash mx-3"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, row);
            }}
          ></i>
        </span>
      ),
    },
  ];

  console.log({ filteredData });
  return (
    <>
      {/* <div className=" mt-2">
        <div className="container">
          <AuctionERPBreadcrumb
            items={[
              { name: "Home", link: "/meratractor" },
              {
                name: "Manage Brand States",
                link: "/meratractor/manage-brands-states",
              },
            ]}
          />
        </div>
      </div> */}
      <div className="container responsive mt-2 mb-3 ">
        <div className="row mt-2">
          <div className="d-flex flex-wrap justify-content-between no-wrap mb-2">
            <div className="col-7 col-md-8 col-lg-8 col-xl-9 mt-2">
              <h4 className="">Manage Brands States</h4>
            </div>
            <div
              className="d-flex justify-content-end col-5 col-md-3 col-lg-3 col-xl-2"
              style={{ marginTop: "5px", marginBottom: "3px" }}
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  setModal(true);
                }}
              >
                <span style={{ marginBottom: "1px", marginRight: "3px" }}>
                  +
                </span>
                Add Brand States
              </button>
            </div>
          </div>
        </div>
        <div className="col-12" style={{ marginBottom: "4px" }}>
          <SearchBox
            allData={brandStateData}
            setFilteredData={setFilteredData}
            return_array={true}
          />
        </div>
      </div>
      {modal && (
        <CreateBrandStatesModalPopup
          show={modal}
          state={stateData}
          brand={brandList}
          setModal={setModal}
          data={modalData}
          initialValue={initialValue}
          setdata={setModalData}
          setLoading={setLoading}
          itemsPerPage={itemsPerPage}
          setBrandStateData={setBrandStateData}
          setFilteredData={setFilteredData}
          onHide={() => {
            setModal(false);
            setModalData(initialValue);
          }}
        />
      )}

      <div className="container mt-2">
        <Table
          columns={columns}
          data={filteredData}
          loading={loading}
          no_data_msg="No Data"
          td_style={{ fontSize: "small" }}
          maxTableHeight="80vh"
        />
      </div>
    </>
  );
};

export default ManageBrandStates;
